export const MESSAGES_LABELS = {
    success : {

    },
    error : {
        AUTH_ERROR_NOT_REGISTERED : 'You are not registered. Please sign up first.',
        FAILED_TO_SEND_OTP : 'Failed to send OTP. Please try again.',
        MOBILE_NUMBER_INVALID : 'Please enter a valid mobile number',
        EMAIL_INVALID : 'Please enter a valid email address',
        EMAIL_OR_MOBILE_REQUIRED : 'Please enter either a mobile number or an email address',
        TERMS_REQUIRED : 'Please agree to the Terms & Conditions and Privacy Policy',
    }
};